import Vue from 'vue'
import {handleTraceFunction} from './trace'
import {throttle} from './util'
let track = Vue.directive('track', {
  bind: (el, binding, vnode) => {
    el.addEventListener('click', () => {
      if (binding.value && binding.value.functionName) {
        // request API
        let newObj = {
          functionName: binding.value.functionName,
          createTime: new Date().getTime()
        }
        if (sessionStorage.getItem('traceObj')) {
          newObj.functionUrl = JSON.parse(`${sessionStorage.getItem('traceObj')}`).functionUrl
          newObj.note = JSON.parse(`${sessionStorage.getItem('traceObj')}`).note
        } else if (localStorage.getItem('functionUrl')) {
          newObj.functionUrl = localStorage.getItem('functionUrl')
        }
        throttle(handleTraceFunction(newObj), 1000)
      }
    }, false)
  }
})

export default track



// WEBPACK FOOTER //
// ./src/utils/vTrace.js